// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
export type UsersImportCredentialsFragment = (
  { __typename?: 'UploadCredentials' }
  & Pick<PrivateSchemaTypes.UploadCredentials, 'filename' | 'params' | 'uploadUrl'>
);

export type UsersImportConfigurationFragment = (
  { __typename?: 'UsersCsvImportConfiguration' }
  & Pick<PrivateSchemaTypes.UsersCsvImportConfiguration, 'fileName' | 'updateExisting' | 'groupId' | 'samples'>
);

export type UsersImportResultFragment = (
  { __typename?: 'UsersCsvImportResult' }
  & { errors?: PrivateSchemaTypes.Maybe<Array<(
    { __typename?: 'UsersImportError' }
    & Pick<PrivateSchemaTypes.UsersImportError, 'lineNumber' | 'message'>
  )>>, stats?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'UsersImportStats' }
    & Pick<PrivateSchemaTypes.UsersImportStats, 'recordsCreated' | 'recordsUpdated'>
  )> }
);

export type UsersImportMappingFragment = (
  { __typename?: 'UsersImportMappingModel' }
  & Pick<PrivateSchemaTypes.UsersImportMappingModel, 'id' | 'title' | 'map'>
);

export type UsersCsvImportModelFragment = (
  { __typename?: 'UsersCsvImportModel' }
  & Pick<PrivateSchemaTypes.UsersCsvImportModel, 'id' | 'status'>
  & { result?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'UsersCsvImportResult' }
    & UsersImportResultFragment
  )>, configuration: (
    { __typename?: 'UsersCsvImportConfiguration' }
    & UsersImportConfigurationFragment
  ), importMapping?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'UsersImportMappingModel' }
    & UsersImportMappingFragment
  )> }
);

export const UsersImportCredentialsFragmentDoc = gql`
    fragment usersImportCredentials on UploadCredentials {
  filename
  params
  uploadUrl
}
    `;
export const UsersImportResultFragmentDoc = gql`
    fragment usersImportResult on UsersCsvImportResult {
  errors {
    lineNumber
    message
  }
  stats {
    recordsCreated
    recordsUpdated
  }
}
    `;
export const UsersImportConfigurationFragmentDoc = gql`
    fragment usersImportConfiguration on UsersCsvImportConfiguration {
  fileName
  updateExisting
  groupId
  samples
}
    `;
export const UsersImportMappingFragmentDoc = gql`
    fragment usersImportMapping on UsersImportMappingModel {
  id
  title
  map
}
    `;
export const UsersCsvImportModelFragmentDoc = gql`
    fragment usersCsvImportModel on UsersCsvImportModel {
  id
  status
  result {
    ...usersImportResult
  }
  configuration {
    ...usersImportConfiguration
  }
  importMapping {
    ...usersImportMapping
  }
}
    ${UsersImportResultFragmentDoc}
${UsersImportConfigurationFragmentDoc}
${UsersImportMappingFragmentDoc}`;